<template>
    <div id="root" class="root">
        <nav id="sidebar">
            <div class="sidebar-header" style="font-size: 1.1em; display: flex; align-items: center;">
                <div style="width: 100%; text-align: center;" @click="selectMenu(0)">
                    <img src="/static/imgs/logols_w.svg" alt="menu" style="width: 30%; margin-top: 5vh; margin-bottom: 2.5vh;">
                </div>
            </div>
            <ul class="list-unstyled components" style="margin-top: 0; overflow-y: scroll; font-size: 4vw;">
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(6)">RESERVAS</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(1)">HISTÓRIA</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(2)">COMODIDADES</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(3)">LOCALIZAÇÃO</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(4)">GASTRONOMIA</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(5)">ACOMODAÇÕES</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(7)">LS EXPERIENCE</a>
                </li>
            </ul>
        </nav>

        <div class="section" id="sidebarCollapse" @click="changeSideBar()">
            <a class="navicon-button x" id="icmenu" >
                <div class="navicon">
                </div>
            </a>
        </div>

        <div class="top-bar" :style="'margin-top: ' + topBarMargin + 'px;'">
            <span class="top-bar-item" @click="selectMenu(6)">RESERVAS</span>
            <span class="top-bar-item" @click="selectMenu(1)">HISTÓRIA</span>
            <span class="top-bar-item" @click="selectMenu(2)">COMODIDADES</span>
            <span class="top-bar-item" @click="selectMenu(3)">LOCALIZAÇÃO</span>
            <img class="top-logo_b" :style="'height: ' + logoHeight + 'vh; margin-top: ' + logoMargin + 'vh;'" src="/static/imgs/logols_marron.svg" @click="selectMenu(0)"/>
            <span class="top-bar-item" @click="selectMenu(4)">GASTRONOMIA</span>
            <span class="top-bar-item" @click="selectMenu(5)">ACOMODAÇÕES</span>
            <span class="top-bar-item">LS EXPERIENCE</span>
            <div class="top-bar-item">
                <a target="_blank" href="https://www.facebook.com/lshoteljp/"><img src="/static/imgs/ic_r_face_b.svg"/></a>
                <a target="_blank" href="https://www.instagram.com/ls_hotel/"><img src="/static/imgs/ic_r_insta_b.svg"/></a>
                <a target="_blank" href="https://www.tripadvisor.com.br/Hotel_Review-g303428-d15241822-Reviews-Ls_Hotel-Joao_Pessoa_State_of_Paraiba.html"><img src="/static/imgs/ic_r_trip_b.svg"/></a>
            </div>
        </div>

        <div class="root_blog">
            <!-- ################ Parte 1 blog  ################ -->
            <div id="part0" class="blog1">
                <div class="blog1_p1" style="width: 100%;">
                    <span class="tx_blog1_destaque"> DESTAQUE </span>
                    <div class="dv_im_container">
                        <div v-for="(item, index) in galery_p1" :key="index" v-if="index < 3">
                            <!--<img class="im_galery" :src="item.path" :title="item.name" style="width: 20vw"/>-->
                            <img class="im_galery" :src="item.path" :title="item.name" :style="'width: ' + item.width"/>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ################ Galeria  ################ -->
            <div id="part2" class="blog1">
                <div class="blog1_p1" style="width: 100%">
                    <span class="tx_blog1_destaque"> GALERIA </span>
                    <div class="dv_im_container">
                        <div v-for="(item, index) in galery_p1" :key="index">
                            <img class="im_galery" :src="item.path" :title="item.name" :style="'width: ' + item.width"/>
                            <!--<img class="im_galery" :src="item.path" :title="item.name" :style="'width: ' + getImgGalWidth(index)"/>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ################ FOOTBAR  ################ -->
        <div id="part7" class="footbar">
            <div class="dv_footbar_container">
                <div class="dv_footbar_colum0">
                    <span class="tx_footbar">CONTATO</span>
                    <span class="tx_footbar_desc">+55 83 3022.2460</span>
                    <span class="tx_footbar_desc">gerencia@lshotel.com.br</span>
                    <span class="tx_footbar_desc">Av. Ingá, 92 - Manaíra</span>
                    <span class="tx_footbar_desc">João Pessoa - Paraíba</span>
                </div>
                <div class="dv_footbar_colum">
                    <span class="tx_footbar" style="justify-content: center;">REDES SOCIAIS</span>
                    <div style="display: flex; align-self: center; justify-self: center; width: 100%; justify-content: center; margin-top: 5%;">
                        <a target="_blank" href="https://www.facebook.com/lshoteljp/"><img class="im_social" src="/static/imgs/ic_r_face_w.svg"/></a>
                        <a target="_blank" href="https://www.instagram.com/ls_hotel/"><img class="im_social" src="/static/imgs/ic_r_insta_w.svg"/></a>
                        <a target="_blank" href="https://www.tripadvisor.com.br/Hotel_Review-g303428-d15241822-Reviews-Ls_Hotel-Joao_Pessoa_State_of_Paraiba.html"><img class="im_social" src="/static/imgs/ic_r_trip_w.svg"/></a>
                        <a target="_blank" href="https://api.whatsapp.com/send?phone=5583991951687"><img class="im_social" src="/static/imgs/ic_whatsapp.svg"/></a>
                    </div>
                </div>
                <div class="dv_footbar_colum2" style="width: 23%;">
                    <span class="tx_footbar">FAÇA PARTE DO NOSSO MAILLING</span>
                    <input style="max-width: 100%; height: 2.5vh; margin-right: 0;" v-model="new_email" :placeholder="tx_digite_email" v-on:keyup.enter="closeKey()" onsubmit="closeKey()"/>
                    <div style="text-align: right; width: 100%;">
                        <span class="bt_enviar" @click="sendNewsletter()">ENVIAR</span>
                    </div>
                </div>
                <div class="dv_footbar_colum2" style="align-items: center; justify-content: center;">
                    <img class="top-logo" src="/static/imgs/logols_w.svg" @click="selectMenu(0)"/>
                </div>
            </div>

            <div style="width: 100%; height: 1vh; display: flex; flex-direction: row;">
                <div style="width: 25%; height: 100%; background-color: #7d6125;"/>
                <div style="width: 25%; height: 100%; background-color: var(--light-yellow);"/>
                <div style="width: 25%; height: 100%; background-color: var(--light-gray-font);"/>
                <div style="width: 25%; height: 100%; background-color: var(--dark-gray);"/>
            </div>

        </div>

        <div v-if="showPopup || showPopup2" class="popup_overlay" @click.prevent.stop="closePopup()">
            <div v-if="showPopup" class="dv_popup_mail3" onclick="event.stopPropagation();">
                <div style="display: flex; width: 100%; justify-content: flex-end;">
                    <div style="width: 3vh; height: 3vh; margin-bottom: -3vh; z-index: 20; cursor: pointer;" @click.prevent.stop="closePopup()">
                        <img src="/static/imgs/ic_fechar.svg" style="background-color: var(--light-gray-font); width: 100%; height: 100%; padding: 0.5vh; margin-left: -0.5vh; margin-top: -0.5vh;"/>
                    </div>
                </div>
                <div style="border-width: 2px; border-style: solid; border-color: var(--light-yellow); height: calc(100% - 4vh); text-align: left; padding: 2vh; display: flex; flex-direction: column; justify-content: space-between;">
                    <div style="display: flex; flex-direction: column;">
                        <span class="tx_popup1">QUER VIVER</span>
                        <span class="tx_popup1">A EXPERIÊNCIA</span>
                        <span class="tx_popup1">LS HOTEL?</span>
                    </div>

                    <!--<a target="_blank" href="https://myreservations.omnibees.com/default.aspx?q=7482" style="width: 80%; display: compact">-->
                        <!--<span class="tx_popup4">Faça sua reserva clicando aqui.</span>-->
                    <!--</a>-->
                    <div style="background-color: var(--dark-brown); display: inline-block; width: fit-content; padding: 0.5vw; cursor: pointer;" @click.prevent.stop="goToURL('https://myreservations.omnibees.com/default.aspx?q=7482')">
                        <span class="tx_popup4">Faça sua reserva</span>
                        <span class="tx_popup4">clicando aqui.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: 'Home',
    data () {
        return {
            name: 'Blog',
            tx_digite_email: 'DIGITE AQUI SEU E-MAIL',
            logoHeight: 8,
            logoMargin: 1.5,
            sel_rest: 0,
            sel_acomodacao: 1,
            topBarMargin: 50,
            quantCriancas: 0,
            quantAdultos: 2,
            tipoSuite: 0,
            new_email: '',
            baseUrlApi: 'https://advice.domm.com.br:8445/AdviceServer/restapi/search/',
            showPopup: false,
            showPopup2: false,
            primeiraVezPopup2: true,
            galery_p1: [
                {
                    name: 'Foto 1',
                    width: '20vw',
                    path: '/static/imgs/bg_home02.jpg'
                },
                {
                    name: 'Foto 1',
                    width: '20vw',
                    path: '/static/imgs/bg_home01.jpg'
                },
                {
                    name: 'Foto 1',
                    width: '20vw',
                    path: '/static/imgs/bg_home00.jpg'
                },
                {
                    name: 'Foto 1',
                    width: '20vw',
                    path: '/static/imgs/bg_home00_2023.jpg'
                },
                {
                    name: 'Foto 1',
                    width: '20vw',
                    path: '/static/imgs/bg_home03.jpg'
                },
                {
                    name: 'Foto 1',
                    width: '20vw',
                    path: '/static/imgs/bg_home03_2023.jpg'
                },
                {
                    name: 'Foto 1',
                    width: '20vw',
                    path: '/static/imgs/im_delux01.jpg'
                },
                {
                    name: 'Foto 1',
                    width: '20vw',
                    path: '/static/imgs/im_delux02.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_delux03.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_premium01.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_premium02.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_premium03.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_presidencial01.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_presidencial02.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_presidencial03.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/bg_home02.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/bg_home01.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/bg_home00.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/bg_home00_2023.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/bg_home03.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/bg_home03_2023.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_delux01.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_delux02.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_delux03.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_premium01.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_premium02.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_premium03.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_presidencial01.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_presidencial02.jpg'
                },
                {
                    name: 'Foto 1',
                    path: '/static/imgs/im_presidencial03.jpg'
                }
            ],
            frases: [
                {
                    autor: 'Rachel Zoe',
                    texto: 'Estilo é uma forma de dizer quem você é sem precisar falar.'
                },
                {
                    autor: '',
                    texto: 'Travel is the only thing you buy that makes you richer.'
                },
                {
                    autor: 'Steve Jobs',
                    texto: 'Vamos inventar o amanhã ao invés de nos preocupar com o que aconteceu ontem.'
                },
                {
                    autor: 'Oscar Wilde',
                    texto: 'Qualquer um que vive medianamente sofre de falta de imaginação'
                },
                {
                    autor: 'Bebe Blues',
                    texto: 'Certos desejos não se matam com beijos de uma boca só'
                }
            ],
            eventos: [
                // {
                //     titulo: 'LS ENCANTADO',
                //     descricao: 'Com referências ao universo lúdico da cultura nordestina, vem aí o Réveillon Encantado do LS Hotel. Teremos uma noite mágica e inesquecível, que ficará ainda mais completa e feliz com a sua presença. Venha receber 2022 no LS Hotel!',
                //     foto: '/static/imgs/im_ev_reve2021.jpg'
                // },
                // {
                //     titulo: 'SUMMER JAZZ',
                //     descricao: 'No dia 29 de janeiro a Adega apresenta a programação musical Summer Jazz, com a cantora Letícia Costa. Teremos uma noite ao som dos clássicos do jazz e do blues americano, além de versões jazzísticas de hits do pop, rock e funk mundial. Entre em contato e reserve sua mesa.',
                //     foto: '/static/imgs/im_ev_summer_jazz.jpg'
                // },
                // {
                //     titulo: 'PRESENTEI SUA MÃE',
                //     descricao: 'Presentei sua mãe com uma experiência especial. Entre em contato para fazer sua reserva.',
                //     foto: '/static/imgs/news_maes.jpg'
                // },
                // {
                //     titulo: 'HOSPEDAGEM COMPLETA',
                //     descricao: 'Entre em contato para conhecer nossas tarifas.',
                //     foto: '/static/imgs/news_hospedagem.jpg'
                // },
                // {
                //     titulo: 'SÃO JOÃO',
                //     descricao: 'Hospede-se no LS Hotel e conheça o Maior São João do Mundo.',
                //     foto: '/static/imgs/im_ev_saojoao2023_1.jpg'
                // },
                // {
                //     titulo: 'SÃO JOÃO',
                //     descricao: 'Hospede-se no LS Hotel e conheça o Maior São João do Mundo.',
                //     foto: '/static/imgs/im_ev_saojoao2023_2.jpg'
                // },
                // {
                //     titulo: 'DIA DOS NAMORADOS',
                //     descricao: 'Celebre o amor no LS Hotel. Entre em contato para fazer sua reserva.',
                //     foto: '/static/imgs/im_ev_namorados2023.jpg'
                // },
                // {
                //     titulo: 'GRAZI VILANEUVA',
                //     descricao: 'Do Jazz à MPB com Grazi Vilanueva. Toda quinta a partir das 20h. Rolha R$80.',
                //     foto: '/static/imgs/im_ev_grazi.jpg'
                // },
                // {
                //     titulo: 'TRIO TOP LINE',
                //     descricao: 'Trio Top Line tocando new jazz. Toda terça a partir das 20h. Rolha livre.',
                //     foto: '/static/imgs/im_ev_trio.jpg'
                // },
                {
                    titulo: 'TRIO JAZZ CONCEPT',
                    descricao: 'Trio Jazz Concept, piano, voz e violino. Toda terça a partir das 20h. Rolha livre.',
                    foto: '/static/imgs/im_ev_jazz3.jpg'
                },
                {
                    titulo: 'TRIO BOSSA CONCEPT',
                    descricao: 'Noite de Bossa Nova com Trio Bossa Concept. Toda quinta a partir das 20h. Rolha R$80.',
                    foto: '/static/imgs/im_ev_bossa3.jpg'
                },
                {
                    titulo: 'DJ MARCOS PORTO',
                    descricao: 'DJ Marcos Porto. Todo sábado das 16h as 20h.',
                    foto: '/static/imgs/im_ev_dj.jpg'
                },
                {
                    titulo: 'CAFÉ DA MANHÃ',
                    descricao: 'Café da manhã na Adega Restaurante. Entre em contato para fazer sua reserva.',
                    foto: '/static/imgs/news_cafe_2.jpg'
                },
                {
                    titulo: 'LS SPA',
                    descricao: 'Agora nossos hóspedes dispõem de um espaço destinado aos serviços de spa, com um menu de massagens desenvolvido especialmente pelo Spa Express. O atendimento funciona mediante agendamento: basta reservar o seu horário e você poderá usufruir de uma experiência relaxante e exclusiva.',
                    foto: '/static/imgs/im_ev_spa_2.jpg'
                },
                {
                    titulo: 'LS LIFESTYLE',
                    descricao: 'Se hospedar no LS Hotel é ter a oportunidade de viver dias incríveis. Além de todo o conforto e qualidade que você encontra em nossa estrutura, ainda é possível incrementar a sua estada com diferentes possibilidades de passeios e atividades. Pensando nisso, nós preparamos um pacote especial para que você aproveite o Lifestyle LS de ser. Entre em contato para conhecer nossas tarifas!',
                    foto: '/static/imgs/im_ev_lifestyle_2.jpg'
                },
                {
                    titulo: 'LITORAL SUL',
                    descricao: 'Piscinas naturais, falésias, arrecifes e um mar de águas claras que hipnotiza os turistas. Assim é o Litoral Sul da nossa região, onde é possível conhecer praias paradisíacas como Coqueirinho, Tambaba e Praia do Amor. Com extensão aproximada de 20km, a costa do Conde é um destino imperdível para quem deseja apreciar nossas belezas naturais, nossa cultura e nossa gastronomia.',
                    foto: '/static/imgs/im_ev_litoral.jpg'
                },
                {
                    titulo: 'PÔR DO SOL DO JACARÉ',
                    descricao: 'Esta é uma das mais clássicas e imperdíveis atrações do turismo paraibano. Diariamente, quando o sol se põe sobre as águas do Rio Paraíba, músicas como “Bolero de Ravel” e "Ave Maria de Gounod” são tocadas ao vivo por um saxofonista dentro de uma embarcação. Além de contemplar este espetáculo da natureza, o turista também encontra uma diversa feira de artesanato no local.',
                    foto: '/static/imgs/im_ev_jacare.jpg'
                },
                {
                    titulo: 'CENTRO HISTÓRICO DE JOÃO PESSOA',
                    descricao: 'Reconhecido como Patrimônio Nacional, nosso Centro Histórico conta com mais de 500 edificações, entre eles, casarões do século XIX e igrejas barrocas que formam o mais importante conjunto arquitetônico da cidade. Para encerrar o passeio, sugerimos uma parada no Hotel Globo: o primeiro hotel de luxo da cidade hoje está desativado, mas tem uma vista privilegiada para o por do sol no Rio Sanhauá.',
                    foto: '/static/imgs/im_ev_centro.jpg'
                },
                {
                    titulo: 'PEDRA DA BOCA',
                    descricao: 'Localizada no município de Araruna, a poucos quilômetros de João Pessoa, a Pedra da Boca é uma formação rochosa de aproximadamente 336 metros de altura e tem esse nome devido a uma cavidade escavada pela erosão que se assemelha a uma grande boca aberta. No local é possível praticar rapel, escalada e caminhadas, contemplando as belas paisagens e a exuberância da fauna e da flora locais.',
                    foto: '/static/imgs/im_ev_pedra.jpg'
                },
                {
                    titulo: 'LAJEDO DE PAI MATEUS',
                    descricao: 'Localizado a poucos quilômetros de João Pessoa, o Lajedo de Pai Mateus é uma elevação rochosa composta por cerca de cem grandes pedras arredondadas. Com cenários paradisíacos, histórias milenares, pinturas rupestres e uma atmosfera extremamente mística, o local já foi cenário de diversas produções cinematográficas. Sem dúvidas uma experiência especial e inesquecível.',
                    foto: '/static/imgs/im_ev_lajedo.jpg'
                }
                // {
                //     titulo: 'MÚSICA DO MUNDO',
                //     descricao: 'Às terças-feiras, o Restaurante Adega recebe uma sofisticada apresentação que contempla os hits clássicos e sucessos contemporâneos da música mundial. O violinista André Correia comanda a noite acompanhado do pianista Igor Wendel.',
                //     foto: '/static/imgs/im_ev_musiscamundo2.jpg'
                // },
                // {
                //     titulo: 'NOITE DE JAZZ',
                //     descricao: 'Todas as quintas acontece no Restaurante Adega, no LS Hotel, a programação musical Do Jazz à MPB. A partir das 20h nossos clientes podem apreciar música da mais alta qualidade na voz da cantora Grazi Vilanueva.',
                //     foto: '/static/imgs/im_ev_jazz_mpb2.jpg'
                // },
                // {
                //     titulo: 'LOUNGE SESSIONS',
                //     descricao: 'Gastronomia Fusion e Japonesa, cardápio de double drinks e discotecagem que funde Lounge, Chill, Deep e House Music: assim é o Loung Sessions, programação que acontece nas noites de quarta no agradável e incomparável terraço do restaurante Ippon.',
                //     foto: '/static/imgs/im_ev_lounge2.jpg'
                // }
            ],
            noticias: [
                // {
                //     titulo: 'Prefeitura anunciou que os shows acontecerão de forma online com a participação de artistas locais e que estuda ampliação de eventos presenciais que não gerem aglomeração.',
                //     categoria: 'Campina Grande mantém shows virtuais no São João 2021',
                //     post_url: '',
                //     foto: '/static/imgs/news_saojoao.jpg'
                // },
                // {
                //     titulo: 'O álbum “Avisa”, da cantora, compositora e musicista paraibana, será lançado no dia 17 de junho, contando com seis releituras e uma canção inédita.',
                //     categoria: 'Lucy Alves regrava músicas do grupo paulistano Falamansa',
                //     post_url: '',
                //     foto: '/static/imgs/news_lucy.jpg'
                // },
                // {
                //     titulo: 'Com alto poder de engajamento nas mídias, Juliette Freire vence o BBB21 ganhando o prêmio de 1,5 milhão e mais uma lista de anunciantes interessados em contratos publicitários.',
                //     categoria: 'Advogada paraibana se torna a nova milionária do país',
                //     post_url: '',
                //     foto: '/static/imgs/news_juliette.jpg'
                // },
                {
                    categoria: 'João Pessoa como “A bola da vez do Nordeste”.',
                    titulo: 'O jornal Valor Econômico destacou o aquecimento do mercado imobiliário em João Pessoa.',
                    post_url: 'https://www.blogdobgpb.com.br/2023/07/01/valor-economico-aponta-joao-pessoa-como-a-bola-da-vez-do-nordeste/',
                    foto: '/static/imgs/news_jp.jpg'
                },
                {
                    titulo: 'Na Clubhouse é possível ouvir ao vivo áudios de qualquer parte do mundo e participar de fóruns, palestras, workshops e debates sobre diversos temas.',
                    categoria: 'Nova rede social chega ao mercado com proposta inovadora',
                    post_url: '',
                    foto: '/static/imgs/news_rede.jpg'
                },
                {
                    titulo: 'O single "Refloresta" foi gravado para uma campanha do Instituto Terra, que clama pelo reflorestamento das terras brasileiras.',
                    categoria: 'Gilberto Gil lança música com seus filhos e netos',
                    post_url: '',
                    foto: '/static/imgs/news_gil.jpg'
                },
                {
                    titulo: 'Segundo dados da Receita Federal, o estado registrou a abertura de 6.334 novos negócios em menos de dois meses, desde o início de 2021.',
                    categoria: 'Paraíba registra mais de 6,3 mil microempresas em 2021',
                    post_url: '',
                    foto: '/static/imgs/news_micro.jpg'
                }
                // {
                //     titulo: 'Disponível nas plataformas de streaming e em formato físico, "Nenhuma dor" traz regravações do repertório da cantora divididas com 10 vozes masculinas.',
                //     categoria: 'Gal Costa lança álbum em celebração aos seus 75 anos de carreira',
                //     post_url: '',
                //     foto: '/static/imgs/news_gal.jpg'
                // },
                // {
                //     titulo: '"Bacurau", filme de Kleber Mendonça Filho e Juliano Dornelles, está na lista dos melhores do ano de Barack Obama. O ex-presidente dos EUA compartilhou a lista em seu perfil no Twitter.',
                //     categoria: 'Barack Obama inclui filme nordestino entre os preferidos do ano',
                //     post_url: '',
                //     foto: '/static/imgs/news_bacurau.jpg'
                // },
                // {
                //     titulo: 'Localizado ao lado da Estação Cabo Branco, o Parque Linear da Estação conta com mais de 8,5 mil m², incluindo ciclofaixas, academia ao ar livre e áreas para o uso de skates e patins.',
                //     categoria: 'João Pessoa ganha nova área de lazer, convivência e práticas esportivas',
                //     post_url: '',
                //     foto: '/static/imgs/news_parque_linear.jpg'
                // },
                // {
                //     titulo: 'Kelner Macêdo é um dos finalistas do prêmio The Brazilian Critic 2020. Ele concorre na categoria Melhor Ator em Série de Comédia, devido à sua atuação na série “Todxs nós”, exibido na HBO Brasil.',
                //     categoria: 'Ator paraibano concorre a prêmio internacional por atuação em série',
                //     post_url: '',
                //     foto: '/static/imgs/news_kelner.jpg'
                // },
                // {
                //     titulo: 'Compra da CoronaVac deverá ser feita ainda em janeiro. A Secretaria Estadual de Saúde já foi autorizada a fazer os contatos iniciais com o governo de São Paulo para acertar a aquisição das doses.',
                //     categoria: 'Governo da Paraíba sinaliza compra de vacinas ao Governo de São Paulo',
                //     post_url: '',
                //     foto: '/static/imgs/news_corona.jpg'
                // },
                // {
                //     titulo: 'Tradicional evento realizado pela Usina Cultural Energisa acontece até o dia 27 de janeiro. A programação contará com 15 lives de shows musicais, além de recitais, espetáculos circenses, atrações infantis e espaços para discussão sobre cultura.',
                //     categoria: '7ª edição do Natal na Usina acontece de forma 100% on-line',
                //     post_url: '',
                //     foto: '/static/imgs/news_natal.jpg'
                // },
                // {
                //     titulo: 'A capital paraibana ficou em primeiro lugar no ranking das capitais brasileiras onde a população mais lê. Segundo a 5ª edição da pesquisa Retratos da Leitura no Brasil, do Instituto Pró-Livro, 64% dos pessoenses são leitores.',
                //     categoria: 'João Pessoa é a capital brasileira onde mais se lê',
                //     post_url: '',
                //     foto: '/static/imgs/news_book.jpg'
                // },
                // {
                //     titulo: 'Saiu a esperada lista das 50 melhores músicas de 2020 pela conceituada revista Rolling Stone. A publicação destacou estilos bem diversos, trazendo um top 10 com nomes como Cardi B, Dua Lipa, The Weeknd, Harry Styles e Lady Gaga.',
                //     categoria: 'Revista Rolling Stone divulga lista das 50 músicas do ano',
                //     post_url: '',
                //     foto: '/static/imgs/news_flor2.jpg'
                // }
            ],
            weather: [],
            momentos: [],
            semanas: [
                'DOM',
                'SEG',
                'TER',
                'QUA',
                'QUI',
                'SEX',
                'SAB'
            ],
            mares_full: [],
            mares: [
                {
                    min: 0.6,
                    // hora: '12:21h'
                    hora: ''
                },
                {
                    min: 0.7,
                    // hora: '13:08h'
                    hora: ''
                },
                {
                    min: 0.8,
                    // hora: '14:06h'
                    hora: ''
                },
                {
                    min: 0.8,
                    // hora: '15:23h'
                    hora: ''
                },
                {
                    min: 0.8,
                    // hora: '16:39h'
                    hora: ''
                },
                {
                    min: 0.6,
                    // hora: '17:45h'
                    hora: ''
                },
                {
                    min: 0.5,
                    // hora: '06:24h'
                    hora: ''
                }
            ],
            slidesVec1: [],
            slidesVec2: [],
            slidesCur1: 1,
            slidesCur2: 1,
            slidesClickTime: 0,
            slidesAutoTime: 5000,
            slide_home: [
                '/static/imgs/bg_home02.jpg',
                '/static/imgs/bg_home01.jpg',
                '/static/imgs/bg_home03.jpg'
            ],
            slide_deluxe: [
                '/static/imgs/im_delux01.jpg',
                '/static/imgs/im_delux02.jpg',
                '/static/imgs/im_delux03.jpg'
            ],
            slide_premium: [
                '/static/imgs/im_premium01.jpg',
                '/static/imgs/im_premium02.jpg',
                '/static/imgs/im_premium03.jpg'
            ],
            slide_presidencial: [
                '/static/imgs/im_presidencial01.jpg',
                '/static/imgs/im_presidencial02.jpg',
                '/static/imgs/im_presidencial03.jpg'
            ],
            slide_suites: [
                '/static/imgs/im_delux01.jpg',
                '/static/imgs/im_delux02.jpg',
                '/static/imgs/im_delux03.jpg'
            ],
            loading: {
                weather: false,
                momento: false,
                feed: false,
                mare: false
            },
            offsetLeft: 0,
            lastIn: 1
        }
    },
    methods: {
        prepareGaleryWidgh () {
            let i
            for (i = 0; i < this.galery_p1.length; i++) {
                if ((i % 3 === 0 && this.lastIn % 3 !== 0) ||
                    i % 5 === 0) {
                    this.lastIn = i
                    this.galery_p1[i].width = '30vw'
                } else {
                    this.galery_p1[i].width = '20vw'
                }
            }
        },
        getImgGalWidth (index) {
            if ((index % 3 === 0 && this.lastIn % 3 !== 0) ||
                index % 6 === 0) {
                this.lastIn = index
                return '30vw'
            } else {
                return '20vw'
            }
        },
        changeSideBar () {
            // console.log('entrei no changeSideBar')
            window.$('#icmenu').toggleClass('open')
            if (!window.$('#sidebar').hasClass('active')) {
                window.$('.overlay').fadeIn()
                window.$('.collapse.in').toggleClass('in')
                window.$('a[aria-expanded=true]').attr('aria-expanded', 'false')
            } else {
                window.$('.overlay').fadeOut()
            }
            window.$('#sidebar').toggleClass('active')
        },
        scrollEstabs (right, inc) {
            var incre
            var vm = this
            // console.log('scrollEstabs: ', el)
            // console.log('inc: ', inc)

            if (inc === undefined) {
                incre = 150
            } else {
                incre = inc
            }
            // console.log('incre: ', incre);
            // console.log('scrollEstabs:el.offset ', el.offset());
            // console.log('scrollEstabs:el.width  ', el.width());

            if (right) {
                this.offsetLeft += incre
                console.log('this.elScroll.width() * 1.6: ', this.elScroll.width() * 1.6)
                console.log('this.offsetLeft: ', this.offsetLeft)
                if (this.offsetLeft > this.elScroll.width() * 1.6) {
                    this.offsetLeft = this.elScroll.width() * 1.6
                }
            } else {
                this.offsetLeft -= incre
                if (this.offsetLeft < 0) {
                    this.offsetLeft = 0
                }
            }

            if (incre < 50) {
                // faz rapido
                this.elScroll.scrollLeft(this.offsetLeft)

                vm.$nextTick(function () {
                    setTimeout(function () {
                        if ((vm.elLeft.is(':hover') && !right) || (vm.elRight.is(':hover') && right)) {
                            vm.scrollEstabs(right, 15)
                        }
                    }, 100)
                })
            } else {
                // faz suave
                this.elScroll.animate({'scrollLeft': this.offsetLeft}, 500)
            }
        },
        reservar () {
            var mes1 = '' + (this.calendario1.mes + 1)
            var mes2 = '' + (this.calendario2.mes + 1)
            if (mes1 < 10) {
                mes1 = '0' + (this.calendario1.mes + 1)
            }
            if (mes2 < 10) {
                mes2 = '0' + (this.calendario2.mes + 1)
            }
            var dia1 = this.calendario1.dia
            // console.log('dia1 len: ' + typeof dia1)
            // console.log('dia1 len: ' + dia1.size())
            var dia2 = this.calendario2.dia
            if (dia1 < 10) {
                dia1 = '0' + dia1
            }
            if (dia2 < 10) {
                dia2 = '0' + dia2
            }

            var dataIn = dia1 + mes1 + this.calendario1.ano
            var dataOut = dia2 + mes2 + this.calendario2.ano

            console.log('Datain ', dataIn)
            console.log('Dataout ', dataOut)

            var url = 'https://myreservations.omnibees.com/default.aspx?q=7482#/&diff=false&CheckIn=' + dataIn + '&CheckOut=' + dataOut + '&Code=&group_code=&loyality_card=&NRooms=1&ad=' + this.quantAdultos + '&ch=' + this.quantCriancas + '&ag=-'
            // https://myreservations.omnibees.com/default.aspx?q=7482#/&diff=false&CheckIn=02122020&CheckOut=19122020&Code=&group_code=&loyality_card=&NRooms=1&ad=1&ch=0&ag=-
            console.log('url: ' + url)
            this.goToURL(url)
        },
        closePopup () {
            if (this.showPopup) {
                this.showPopup = false
            } else {
                this.showPopup2 = false
            }
        },
        closeKey () {
            console.log('closeKeyboard')
            this.sendNewsletter()
        },
        selectRestaurante (i) {
            this.sel_rest = i
        },
        selectAcomodacao (i) {
            this.sel_acomodacao = i
            switch (i) {
            case 1: this.slide_suites = this.slide_deluxe; break
            case 2: this.slide_suites = this.slide_premium; break
            case 3: this.slide_suites = this.slide_presidencial; break
            }
        },
        selectMenu (i) {
            console.log('selectMenu: ' + i)

            if (this.isMobile()) {
                this.changeSideBar()
            }

            this.$router.push({params: {menuIndex: i}, name: '/'})
        },
        addEvent (obj, type, fn) {
            if (obj.attachEvent) {
                obj['e' + type + fn] = fn
                obj[type + fn] = function () { obj['e' + type + fn](window.event) }
                obj.attachEvent('on' + type, obj[type + fn])
            } else {
                obj.addEventListener(type, fn, false)
            }
        },
        isMobile () {
            if (window.innerWidth < 861) {
                return true
            } else {
                return false
            }
        },
        handleScrool (event) {
            // console.log('el.scrollHeight ', this.elPart0.scrollHeight)
            // console.log('event ', window.scrollY)

            if (this.isMobile()) {
                this.logoHeight = 5
                this.topBarMargin = 0
                this.logoMargin = 0
                return
            }

            if (window.scrollY > this.elPart0.scrollHeight) {
                this.topBarMargin = 0
                this.logoHeight = 5
                this.logoMargin = 0
            } else {
                let diff = this.elPart0.scrollHeight - window.scrollY
                this.topBarMargin = Math.round(diff * 0.05)
                let p = diff / this.elPart0.scrollHeight
                this.logoHeight = 4 + 4 * p
                this.logoMargin = 1.5 * p
                // console.log('this.elPart0.scrollHeight: ', this.elPart0.scrollHeight)
                // console.log('window.scrollY: ', window.scrollY)
                // console.log('diff: ', diff)
                // console.log('percentual: ', p)
            }
            // console.log('logoHeight: ', this.logoHeight)
            // console.log('logoMargin: ', this.logoMargin)
        },
        goToURL (url) {
            window.open(url, '_blank')
            // location.href = url
        },
        sendNewsletter () {
            var vw = this

            console.log('sendNewsletter ' + this.new_email)
            if (!this.checkEmail()) {
                alert('Endereço de e-mail inválido.')
            } else {
                var url = this.baseUrlApi + 'addnewsletter'

                var data = {
                    'email': this.new_email,
                    idlocal: 100
                }

                console.log('Enviando post com o newsletter')
                console.log(url)
                axios.post(url, qs.stringify(data))
                    .then(function (response) {
                        // vm.loading.form = false;
                        console.log('SUCESS::' + response)
                        vw.showPopup = false
                        vw.showPopup2 = false
                    })
                    .catch(function (error) {
                        // vm.loading.form = false;
                        console.log('ERROR::' + error)
                    })

                this.sleep(1000).then(() => {
                    alert('Que bom que você está conosco, aproveite a viagem!')

                    // TODO remover essas 2 atribuicoes
                    vw.showPopup = false
                    vw.showPopup2 = false
                })
            }
        },
        checkEmail () {
            var email = this.new_email
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        sleep (time) {
            return new Promise((resolve) => setTimeout(resolve, time))
        },
        moveSlide (index, right, manualClick = true) {
            console.log('moveSlide' + index)
            var currTime = Date.now()
            var slidesVec
            var slidesCur
            if (manualClick) {
                this.bannerAutoSlide = true
            }

            if (currTime - this.slidesClickTime < 700) {
                console.log('moveSlide::return because time interval is too short')
                return
            }

            if (!manualClick && (currTime - this.slidesClickTime < this.slidesAutoTime)) {
                console.log('moveSlide::tempo de espera errado.')
                return
            }

            if (!this.bannerAutoSlide) {
                console.log('moveSlide::Nao eh para momento do auto slide.')
                return
            }

            if (index === 1) {
                slidesVec = this.slidesVec1
                slidesCur = this.slidesCur1
            } else {
                slidesVec = this.slidesVec2
                slidesCur = this.slidesCur2
            }

            this.slidesClickTime = currTime

            console.log('moveSlide::Movendo slide para: ' + right + ', manualClick: ' + manualClick + ', bannerAutoSlide: ' + this.bannerAutoSlide)
            // Get all the slides again
            var slides = window.$('.slide' + index)
            // console.log('slides: ', slides)

            // Register active slide
            // var activeSlide = $('.active');
            var activeSlide = slidesVec[slidesCur]

            // Next function
            if (right) {
                slidesCur = (slidesCur + 1) % slidesVec.length

                // Move first slide to the end so the user can keep going forward
                slides.last().after(slides.first())
                // Move active class to the right
                activeSlide.removeClass('active').next('.slide' + index).addClass('active')
            } else {
                slidesCur--
                if (slidesCur < 0) {
                    slidesCur = slidesVec.length - 1
                }

                // Move the last slide before the first so the user can keep going backwards
                slides.first().before(slides.last())
                // Move active class to the left
                activeSlide.removeClass('active').prev('.slide' + index).addClass('active')
            }

            if (index === 1) {
                this.slidesVec1 = slidesVec
                this.slidesCur1 = slidesCur
            } else {
                this.slidesVec2 = slidesVec
                this.slidesCur2 = slidesCur
            }

            if (this.bannerAutoSlide) {
                var vm = this
                setTimeout(function () {
                    vm.moveSlide(index, true, false)
                }, vm.slidesAutoTime)
            }
        },
        prepareSlider () {
            // Get all the slides again
            var vec = window.$('.slide1')
            this.slidesVec1.push(vec.first())
            this.slidesVec1.push(vec.first().next())
            this.slidesVec1.push(vec.last())
            vec = window.$('.slide2')
            this.slidesVec2.push(vec.first())
            this.slidesVec2.push(vec.first().next())
            this.slidesVec2.push(vec.last())

            // console.log('this.slidesVec: ', this.slidesVec)

            // this.mobile = this.isMobile()

            var vm = this
            setTimeout(function () {
                vm.moveSlide(1, true, true)
            }, vm.slidesAutoTime)
        },
        parseMeuMomento (json) {
            console.log('json: ', json)
            var lista = json.hashtag.edge_hashtag_to_media.edges
            this.momentos = []

            console.log('lista: ', lista)
            var max = 10
            if (lista.length < 10) {
                max = lista.length
            }
            for (let i = 0; i < max; i++) {
                var item = lista[i]
                var foto = ''
                if (item.node.thumbnail_resources.length >= 4) {
                    foto = item.node.thumbnail_resources[3].src
                } else {
                    foto = item.node.thumbnail_src
                }

                console.log('node ' + i + ': ', item.node)

                var info = {
                    foto: foto,
                    post_url: 'https://www.instagram.com/p/' + item.node.shortcode
                }
                console.log('info ' + i + ': ', info)

                this.momentos.push(info)
            }

            console.log('momentos: ', this.momentos)
        },
        downloadMeuMomento () {
            var vm = this

            var urlconverter = 'https://jsonp.afeld.me/?url='
            var urlfeed = 'https://www.instagram.com/explore/tags/meumomentols/?__a=1'

            var url = urlconverter + encodeURIComponent(urlfeed)

            this.loading.momento = true

            axios.get(url)
                .then(function (response) {
                    vm.loading.momento = false
                    console.log('downloadMeuMomento::Response.data ', response.data)
                    console.log('downloadMeuMomento::Response.status ' + response.status)
                    if (response.status === 200) { // ADDED
                        console.log('downloadMeuMomento::Status::200::Tudo certo')
                        console.log('Response.data ', response.data)

                        vm.parseMeuMomento(response.data.graphql)
                    } else {
                        console.log(response.status + ' Erro receber meu momento.')
                    }
                    vm.loading.momento = false
                })
                .catch(function (error) {
                    console.log('downloadMeuMomento::ERROR:: ' + error)
                    vm.loading.momento = false
                })
        },
        parseNewsFeed (json) {
            // console.log('json: ', json)
            var lista = json.items
            this.noticias = []

            // console.log('lista: ', lista)
            var max = 10
            if (lista.length < 10) {
                max = lista.length
            }
            for (let i = 0; i < max; i++) {
                var item = lista[i]

                var info = {
                    titulo: item.title,
                    foto: item.thumbnail,
                    categoria: 'POP & ARTE',
                    post_url: item.link
                }

                this.noticias.push(info)
            }

            console.log('noticias: ', this.noticias)
        },
        downloadNewsFeed () {
            var vm = this
            var urlconverter = 'https://api.rss2json.com/v1/api.json?rss_url='
            var urlfeed = 'http://g1.globo.com/dynamo/pop-arte/rss2.xml'

            this.loading.feed = true

            // fetch(url)
            axios.get(urlconverter + urlfeed)
                .then(function (response) {
                    vm.loading.feed = false
                    console.log('downloadNewsFeed::Response.data ', response.data)
                    console.log('downloadNewsFeed::Response.status ' + response.status)
                    if (response.status === 200) { // ADDED
                        console.log('downloadNewsFeed::Status::200::Tudo certo')

                        vm.parseNewsFeed(response.data)

                        // console.log('Response.data ', response.data)
                    } else {
                        console.log(response.status + ' Erro ao receber news feed.')
                    }
                    vm.loading.feed = false
                })
                .catch(function (error) {
                    console.log('downloadNewsFeed::ERROR:: ' + error)
                    vm.loading.feed = false
                })
        },
        parseTabuaMare (data) {
            // Parse HTML
            var el = document.createElement('html')
            el.innerHTML = data
            // var lista = el.getElementsByClassName('tabua')
            // var lista = el.getElementsByClassName('arrudeia_item_previsao')
            var lista = el.getElementsByTagName('tbody')[1].getElementsByTagName('tr')

            // console.log('xmlDoc: ', xmlDoc)

            // var lista = xmlDoc.getElementsByClassName('tabua')

            console.log('lista: ', lista)

            this.mares_full = []

            var max = 10
            if (lista.length < 10) {
                max = lista.length
            }
            for (let i = 0; i < max; i++) {
                var item = lista[i].getElementsByTagName('td')

                // console.log('item ', item)
                // console.log('item2[0] ', item[2].getElementsByClassName('mare')[0].textContent)
                // console.log('item2[1] ', item[2].getElementsByClassName('mare')[1].textContent)
                // console.log('item[4]: ', item[4].getElementsByClassName('mare')[1].textContent)
                // console.log('item[4].trim: ', item[4].getElementsByClassName('mare')[1].textContent.trim())

                let info = {
                    data: item[0].textContent.trim(),
                    mares: []
                }

                for (let j = 0; j < 4; j++) {
                    let mare = {
                        hora: item[2 + j].getElementsByClassName('mare')[0].textContent.trim(),
                        altu: item[2 + j].getElementsByClassName('mare')[1].textContent.trim()
                    }

                    // convert to HHhMM to HH:MMh
                    mare.hora = mare.hora.replace('h', ':') + 'h'

                    // convert to number
                    mare.altu = Number(mare.altu.substring(0, mare.altu.length - 1))

                    info.mares.push(mare)
                }

                // remove lua info
                if (info.data.length > 10) {
                    info.data = info.data.substring(0, 10)
                }

                console.log('info: ', info)
                this.mares_full.push(info)
            }

            // convert mares_full to mares
            this.mares = []
            let indMare = 0
            for (let i = 0; i < max; i++) {
                let info = this.mares_full[i]

                let dia = Number(info.data.substring(0, 2))
                let menorAlt = 10
                let menorIndex = 0
                // console.log('dia: ', dia)

                if (dia >= this.dia) {
                    for (let j = 0; j < 4; j++) {
                        if (info.mares[j].altu < menorAlt && info.mares[j].hora.length > 1) {
                            menorAlt = info.mares[j].altu
                            menorIndex = j
                        }
                    }
                    this.mares.push({
                        hora: info.mares[menorIndex].hora,
                        min: info.mares[menorIndex].altu
                    })
                    indMare++
                    if (indMare >= 7) {
                        break
                    }
                }
            }
        },
        downloadTabuaMare () {
            var vm = this

            var urlconverter = 'https://jsonp.afeld.me/?url='
            // var urlconverter = 'https://thingproxy.freeboard.io/fetch/'
            // var urlsite = 'http://ondas.cptec.inpe.br/~rondas/mares/index.php?cod=30540&mes=' + this.mes + '&ano=' + this.ano
            // var urlsite = 'https://www.surfguru.com.br/previsao/mare/30540'
            var urlsite = 'http://www.apolo11.com/mare.php?local=25'
            var url = urlconverter + encodeURIComponent(urlsite)

            console.log('urlsite: ' + urlsite)
            console.log('encode(urlsite): ' + encodeURIComponent(urlsite))
            console.log('url: ' + url)

            this.loading.mare = true

            axios.get(url)
                .then(function (response) {
                    vm.loading.mare = false
                    // console.log('downloadTabuaMare::Response.data ', response.data)
                    console.log('downloadTabuaMare::Response.status ' + response.status)
                    if (response.status === 200) { // ADDED
                        console.log('downloadTabuaMare::Status::200::Tudo certo')

                        vm.parseTabuaMare(response.data)
                    } else {
                        console.log(response.status + ' Erro ao receber tabua das mares.')
                    }
                    vm.loading.mare = false
                })
                .catch(function (error) {
                    console.log('downloadTabuaMare::ERROR:: ' + error)
                    vm.loading.mare = false
                })
        },

        parseWeatherClimaTempo (data) {
            // console.log('data: ', data)

            var lista = data.data

            // console.log('lista: ', lista)

            this.weather = []

            var max = 7
            if (lista.length < 7) {
                max = lista.length
            }
            for (let i = 0; i < max; i++) {
                var item = lista[i]
                var info = {
                    dia: item.date,
                    tempo: item.text_icon.icon.day,
                    max: Number(item.temperature.max),
                    min: Number(item.temperature.min),
                    img: ''
                }

                // http://servicos.cptec.inpe.br/XML/
                if (info.tempo === '2' || info.tempo === '4') {
                    info.img = '/static/imgs/ic_t_nuvem_sol.svg'
                }
                if (info.tempo === '3' || info.tempo === '3n' || info.tempo === '4r' || info.tempo === '5' || info.tempo === '6' ||
                    info.tempo === '7' || info.tempo === '8') {
                    info.img = '/static/imgs/ic_t_chuva.svg'
                }
                if (info.tempo === '1' || info.tempo === '9') {
                    info.img = '/static/imgs/ic_t_sol.svg'
                }
                if (info.tempo === '3TM' || info.tempo === '2r') {
                    info.img = '/static/imgs/ic_t_nuvem.svg'
                }

                // console.log('info: ', info)
                this.weather.push(info)
            }

            // console.log('momentos: ', this.momentos)
        },
        parseWeatherINPE (data) {
            // console.log('data: ', data)
            var parser = new DOMParser()
            var xmlDoc = parser.parseFromString(data, 'text/xml')

            var lista = xmlDoc.getElementsByTagName('cidade')[0].getElementsByTagName('previsao')

            // console.log('lista: ', lista)

            this.weather = []

            var max = 7
            if (lista.length < 7) {
                max = lista.length
            }
            for (let i = 0; i < max; i++) {
                var item = lista[i]
                var info = {
                    dia: item.childNodes[0].textContent,
                    tempo: item.childNodes[1].textContent,
                    max: Number(item.childNodes[2].textContent),
                    min: Number(item.childNodes[3].textContent),
                    img: ''
                }

                // http://servicos.cptec.inpe.br/XML/
                if (info.tempo === 'ec' || info.tempo === 'ci' || info.tempo === 'in' || info.tempo === 'pp' || info.tempo === 'cm' ||
                    info.tempo === 'cn' || info.tempo === 'pt' || info.tempo === 'pm' || info.tempo === 'np' || info.tempo === 'pc' ||
                    info.tempo === 'cv' || info.tempo === 'nd' || info.tempo === 'pnt') {
                    info.img = '/static/imgs/ic_t_nuvem_sol.svg'
                }
                if (info.tempo === 'c' || info.tempo === 'ch' || info.tempo === 't' || info.tempo === 'g' || info.tempo === 'ne' ||
                    info.tempo === 'psc' || info.tempo === 'pcm' || info.tempo === 'pct' || info.tempo === 'pcn' || info.tempo === 'ct') {
                    info.img = '/static/imgs/ic_t_chuva.svg'
                }
                if (info.tempo === 'pn' || info.tempo === 'ps' || info.tempo === 'cl') {
                    info.img = '/static/imgs/ic_t_sol.svg'
                }
                if (info.tempo === 'e' || info.tempo === 'n' || info.tempo === 'npt' || info.tempo === 'npn' || info.tempo === 'ncn' ||
                    info.tempo === 'nct' || info.tempo === 'ncm' || info.tempo === 'npm' || info.tempo === 'npp' || info.tempo === 'vn' ||
                    info.tempo === 'ppn' || info.tempo === 'ppt' || info.tempo === 'ppm') {
                    info.img = '/static/imgs/ic_t_nuvem.svg'
                }

                // console.log('info: ', info)
                this.weather.push(info)
            }

            // console.log('momentos: ', this.momentos)
        },
        downloadWeatherClimaTempo () {
            var vm = this
            var urlsite = 'https://apiadvisor.climatempo.com.br/api/v1/forecast/locale/7364/days/15?token=9b5a7a971541301a8db4acb43b0bc205'

            this.loading.weather = true

            console.log('url wether: ', urlsite)

            axios.get(urlsite)
                .then(function (response) {
                    vm.loading.weather = false
                    console.log('downloadWeatherClimaTempo::Response.data ', response.data)
                    console.log('downloadWeatherClimaTempo::Response.status ' + response.status)
                    if (response.status === 200) { // ADDED
                        console.log('downloadWeatherClimaTempo::Status::200::Tudo certo')
                        console.log('Response.data ', response.data)

                        vm.parseWeatherClimaTempo(response.data)
                    } else {
                        console.log(response.status + ' Erro receber weather.')
                    }
                    vm.loading.weather = false
                })
                .catch(function (error) {
                    console.log('downloadWeatherClimaTempo::ERROR:: ' + error)
                    vm.loading.weather = false
                })
        },
        downloadWeatherINPE () {
            var vm = this
            var urlsite = 'http://servicos.cptec.inpe.br/XML/cidade/7dias/231/previsao.xml'
            var urlconverter = 'https://jsonp.afeld.me/?url='
            var url = urlconverter + encodeURIComponent(urlsite)

            this.loading.weather = true

            console.log('url wether: ', url)

            axios.get(url)
                .then(function (response) {
                    vm.loading.weather = false
                    console.log('downloadWeatherINPE::Response.data ', response.data)
                    console.log('downloadWeatherINPE::Response.status ' + response.status)
                    if (response.status === 200) { // ADDED
                        console.log('downloadWeatherINPE::Status::200::Tudo certo')
                        console.log('Response.data ', response.data)

                        vm.parseWeatherINPE(response.data)
                    } else {
                        console.log(response.status + ' Erro receber weather.')
                    }
                    vm.loading.weather = false
                })
                .catch(function (error) {
                    console.log('downloadWeatherINPE::ERROR:: ' + error)
                    vm.loading.weather = false
                })
        },
        getSemana (i) {
            return this.semanas[(this.indexDia + i) % 7]
        }
    },
    created () {
        console.log('Saindo do Created')

        if (this.isMobile()) {
            this.logoHeight = 5
            this.topBarMargin = 0
            this.logoMargin = 0
        }

        this.prepareGaleryWidgh()

        var dt = new Date()
        this.indexDia = dt.getDay()
        this.ano = dt.getFullYear() - 2000
        this.mes = dt.getMonth()
        this.dia = dt.getDate()
    },
    mounted () {
        console.log('Entrando do Mounted')
        global.jQuery = require('jquery')
        window.$ = global.jQuery

        this.elScroll = window.$('#scrollhorizontal')
        this.elRight = window.$('#scrollright')
        this.elLeft = window.$('#scrollleft')
        this.elPart0 = document.getElementById('part0')

        if (this.isMobile()) {
            this.logoHeight = 5
            this.topBarMargin = 0
            this.logoMargin = 0
        } else {
            this.topBarMargin = Math.round(this.elPart0.scrollHeight * 0.05)
            this.logoHeight = 8
            this.logoMargin = 1.5
        }

        this.addEvent(window, 'scroll', this.handleScrool)

        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0

        console.log('Saindo do Mounted')
    }
}
</script>

<style src="../assets/css/side_bar.css" scoped/>
<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/ls.css" scoped/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Galery.vue